import { html } from 'lit';
import { PimsterDialogRenderProps } from './pimster-dialog.types';
import { IFRAME_ELEMENT_ID } from './pimster-dialog.constants';

const pimsterDialogRender = ({
  isOpen,
  iframe: { src, title },
  close,
}: PimsterDialogRenderProps) => html`
  <div class="wrapper ${isOpen ? 'open' : ''}" aria-hidden="${!isOpen}">
    <div class="overlay" @click=${close} aria-hidden=${!isOpen}></div>
    <div class="dialog" role="dialog">
      <iframe
        id="${IFRAME_ELEMENT_ID}"
        src=${src !== '' ? src : 'about:blank'}
        title=${title}
        allow="autoplay; clipboard-read; clipboard-write"
      ></iframe>
    </div>
  </div>
`;
export default pimsterDialogRender;
